import { render, staticRenderFns } from "./Panel-Slider-Module.vue?vue&type=template&id=d919f6ae&"
import script from "./Panel-Slider-Module.vue?vue&type=script&lang=js&"
export * from "./Panel-Slider-Module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports